// web_components/wcNotification/wcNotification_Renderer.ts

import { NotificationType } from '../../utils/NotificationService';

/**
 * Generates the HTML for the wc-notification component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};
	const { title, message, type } = variables;

	// Determine the appropriate aria-live value based on the notification type
	const ariaLive = type === NotificationType.error ? 'assertive' : 'polite';

	// Construct the CSS class string, including the dynamic notification type
	const notificationClass = `wc-notification wc-notification--${type}`;

	return `
        <div 
            id="${instanceId}"
            class="${notificationClass}" 
            data-state="visible" 
            role="alert" 
            aria-live="${ariaLive}" 
            aria-atomic="true"
        >
			${
				title
					? `
            <h2 class="wc-notification__title">${title}</h2>
            `
					: ''
			}
            <p class="wc-notification__message">${message}</p>
            <button class="wc-notification__close" aria-label="Close notification">&times;</button>
        </div>
    `;
}
